<template>
  <v-card
    color="#385F73"
    dark
  >
    <v-card-title>Ticket {{ ticket.uid }}</v-card-title>

    <v-card-text>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Naam</v-list-item-title>
          <v-list-item-subtitle>{{ ticket.full_name }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>Phone number</v-list-item-title>
          <v-list-item-subtitle>{{ ticket.phone_number }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if=ticket.allergy.length>
        <v-list-item-content>
          <v-alert type='warning'>
            <strong>Allergy!</strong>
            <p>{{ ticket.allergy }}</p>
          </v-alert>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if=ticket.is_checked_in two-line>
        <v-list-item-content>
          <v-list-item-title>Checked in at</v-list-item-title>
          <v-list-item-subtitle>{{ ticket.check_in }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
    <v-card-text>
      <v-alert v-if=alert :type=alert.type>
        {{alert.text}}
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if=!ticket.is_checked_in text @click="checkIn(ticket.uid)" :loading=loading>Check in</v-btn>
      <v-btn v-else text @click="checkOut(ticket.uid)" :loading=loading>Check out</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import TicketMixin from '@/mixins/TicketMixin';
export default {
  mixins: [TicketMixin],
  props: {
    ticket: Object,
  },
}
</script>